import { action } from '@ember/object';
import type Owner from '@ember/owner';

import { BillingFeature } from 'webapp/enums/enums';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensReportsComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	trackingOrigin = 'reports';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.titleText = 'Gather your stakeholders around the data';
		this.descText =
			'Create a comprehensive written report, then share it with stakeholders in just a few clicks.';

		this.topImageLightUrl = '/images/placeholders/reports.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/reports.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-reports.svg';

		this.readMoreUrl = 'https://help.databox.com/create-a-slide-presentation';
		this.trialFeatures = [BillingFeature.REPORTS_BASIC];

		this.videoUrl = 'https://player.vimeo.com/video/892392073';

		this.mainActions = [
			{
				action: this.create,
				icon: 'Plus',
				text: 'New report',
				isForCreating: true,
			},
		];

		if (this.accountService.showPublicTemplates) {
			this.mainActions.push({
				action: this.openPublicTemplates,
				icon: 'FolderOpen',
				text: 'Use a template',
			});
		}

		this.arrowText = 'Select an option to get started with your first report';
		this.isArrowInTheMiddle = true;
	}

	override get isNewSectionShown() {
		return this.isAnyActionShown && !this.mustUpgrade && !this.isCurrentUserViewer;
	}

	@action
	openPublicTemplates() {
		this.navigationService.transitionToRoute('reports.public-templates');
	}
}
